/*
*
* Form validation
* Uses Validate.js - Site: https://validatejs.org/
* Placeholder.min.js should be included on all sites to support placeholders on IE9
*
*/

// *** FUNCTION FLOW ***
// --- On page load ---
// Initialize form if class exists -> Attach submit listener to form submit button
// --- On submit click ---
// handleFormSubmit() gets the constraints (default and project specific) and then validates based on constraints ->
// showValidationErrors() grabs inputs -> showErrorsForInput() handles radio input errors directly and passes off others ->
// manipulateDomErrorDisplay() attaches each error to inputs with names that match the given rules ->
// addInputEventListener() adds a listener that re-validates on input change (IF THERE WAS AN ERROR) ->
// submitTheValidForm() submits the actual form data (IF THERE ARE NO ERRORS)
// --- On input (after error submitting) ---
// individualInputSubmit() checks re-validates field -> checkSingleValidationError() re-validates single input

// *** STEPS TO IMPLEMENT ON SITE ***
// Add 'js-validateForm' class to each form
// Make sure the form submission button is a button with type 'submit'
// Wherever you want the error message to appear, make sure to include a tag with a class of 'error-message [FIELDNAME]'
// Add a css entry for error-message { display: none }

// *** MULTISTEP FORM REQUIREMENTS ***
// Final submit button must be a button with type 'submit'
// Any buttons that change the form step must be labeled with the 'data-step-change' attribute
// Each step of the form must be contained in a div with the 'data-step' attribute

// Default options used to generate real constraints
// These rules only prevent submission if a field with that name exists inside the form (and is marked required)

//keeping track of network errors
var errorNum = 0;
var errorMax = 2;

var defaultConstraints = {
    // FULL NAME
    full_name: {
        // Name is required
        presence: {
            message: "^Name is required"
        },
        // Name must contain at least 2 letters
        length: {
            minimum: 2,
            message: "^Name must be at least 2 characters"
        },
        // We don't allow anything that contains numbers
        format: {
            pattern: "[a-z A-Z]+",
            message: "^Name can only contain letters"
        }
    },
    // FIRST NAME
    first_name: {
        // Name is required
        presence: {
            message: "^First name is required"
        },
        // Name must contain at least 2 letters
        length: {
            minimum: 2,
            message: "^First name must be at least 2 characters"
        },
        // We don't allow anything that contains numbers
        format: {
            pattern: "[a-z A-Z]+",
            message: "^First name can only contain letters"
        }
    },
    // LAST NAME
    last_name: {
        // Name is required
        presence: {
            message: "^Last name is required"
        },
        // Name must contain at least 2 letters
        length: {
            minimum: 2,
            message: "^Last name must be at least 2 characters"
        },
        // We don't allow anything that contains numbers
        format: {
            pattern: "[a-z A-Z]+",
            message: "^Last name can only contain letters"
        }
    },
    // PHONE
    phone: {
        // Phone is required
        presence: {
            message: "^Phone number is required"
        },
        // Phone required to be valid US phone number. First number in area code and phone can't be 1 or 0.
        format: {
            pattern: /\([2-9][0-9]{2}\)\ [2-9][0-9]{2}-[0-9]{4}/,
            message: "^Phone must be a valid US Phone Number"
        }
    },
    // BEST TIME TO CALL
    best_time_to_call: {
        // Best time to call is required
        presence: {
            message: "^Select an option"
        }
    },
    text_consent: {
        presence: {
            message: "^Agreement is required"
        }
    },
    //EMAIL
    email: {
        // Email is required
        presence: {
            message: "^Email is required"
        },
        // and must be an email (duh)
        email: {
            message: "^Email is invalid"
        }
    },
    // ADDRESS
    address: {
        // Address is required
        presence: {
            message: "^Address is required"
        },
        format: {
            // Must be numbers followed by a name
            pattern: "^[0-9]+ .+$",
            message: "^Address must be a valid street name"
        }
    },
    // ZIP CODE
    zip_code: {
        // Zip code is required
        presence: {
            message: "^Zip code is required"
        },
        // Rule is not needed as long as we are preventing alphabetical input
        // // Zip code should only contain numbers
        // format: {
        //     pattern: "[0-9]+",
        //     message: "^Zip code can only contain numbers"
        // },
        // Zip code must be 5 characters (after masking)
        format: {
            pattern: /^[0-9]{5}(-[0-9]{4})?$/,
            message: "^Zip code is invalid"
        }
    },
    // COUNTRY
    country: {
        // Country is required
        presence: {
            message: "^Country is required"
        }
    },
    // COMMENTS
    comments: {
        // Comments are required
        presence: {
            message: "^Comment is required"
        }
    },
    // REQUESTED SERVICE
    requested_service: {
        presence: {
            message: "^Select an option"
        }
    },
    // CAUSE
    cause: {
        // Cause is required
        presence: {
            message: "^Select an option"
        }
    },
    // Cause c_id
    c_id: {
        // Cause c_id is required
        presence: {
            message: "^Select an option"
        }
    },
    // effect
    effect: {
        // Effect is required
        presence: {
            message: "^Select an option"
        }
    },
    // MILITARY BRANCH
    military_branch: {
        // Military branch is required
        presence: {
            message: "^Select an option"
        }
    },
    // VACCINE YEAR
    vaccine_year: {
        // Vaccine year is required
        presence: {
            message: "^Select a year"
        }
    },
    // VACCINE TYPE
    vaccine_type: {
        // Vaccine type is required
        presence: {
            message: "^Select an option"
        }
    },
    // TCPA AGREEMENT
    tcpa_agreement: {
        presence: {
            message: "^Agreement is required"
        }
    },
    // QUOTE AMOUNT
    quote_amount: {
        // Quote amount is required
        presence: {
            message: "^Insert quote amount"
        },
        // Quote amount should only contain numbers
        format: {
            pattern: "[0-9]+",
            message: "^Quote amount can only contain numbers"
        }
    },
    // PAYMENT AMOUNT
    payment_amount: {
        // Payment amount is required
        presence: {
            message: "^Insert payment amount"
        },
        // Payment amount should only contain numbers
        numericality: {
            greaterThan: 0,
            message: "^Payment Amount must be greater than 0"
        }
    },
    // TYPE OF PAYMENTS
    type_of_payment: {
        // Type of payments is required
        presence: {
            message: "^Select a type of payment"
        }
    },
    // NUMBER OF PAYMENTS
    number_of_payments: {
        // Number of payments is required
        presence: {
            message: "^Insert the amount of payments you are receiving"
        },
        // Number of payments should only contain numbers
        numericality: {
            greaterThan: 0,
            message: "^Payment Remaining must be greater than 0"
        }
    },
    // PAYMENT PERIOD
    payment_period: {
        // Payment period is required
        presence: {
            message: "^Select how often you receive payments"
        }
    },
    // PAYMENT START DATE
    payment_start_date: {
        // Payment start date is required
        presence: {
            message: "^Select a date"
        }
    },
    // PAYMENT START DATE
    payment_month: {
        // Payment start date is required
        presence: {
            message: "^Select a month"
        }
    },
    // PAYMENT START DATE
    payment_year: {
        // Payment start date is required
        presence: {
            message: "^Select a year"
        }
    },
    company: {
        // Company is required
        presence: {
            message: "^Company is required"
        }
    },
    // JOB TITLE
    job_title: {
        // Job title is required
        presence: {
            message: "^Job title is required"
        }
    },
    // FAULT
    fault: {
        // Fault is required
        presence: {
            message: "^Please select an option"
        }
    },
    // CPAP
    cpap: {
        // Cpap is required
        presence: {
            message: "^Please select an option"
        }
    },
    cpap_effect: {
      // Cpap is required
      presence: {
          message: "^Please select an option"
      }
    },
    // TikTok
    tiktok: {
        // tiktok is required
        presence: {
            message: "^Please select an option"
        }
    },
    // ASDS
    asds: {
        // ASDS is required
        presence: {
            message: "^Please select an option"
        }
    },
    // SERIOUS INJURY
    serious_injury: {
        // Serious injury is required (haha)
        presence: {
            message: "^Please select an option"
        }
    },
    // DIAGNOSIS
    diagnosis: {
        // Diagnosis is required
        presence: {
            message: "^Please select a diagnosis"
        }
    },
    // REQUESTED SERVICE DETAIL
    requested_service_detail: {
        // Requested service detail is required
        presence: {
            message: "^Please select a department"
        }
    },
    // CCPA
    ccpa_type: {
        // CCPA type
        presence: {
            message: "^Please select a request type"
        }
    },
    // State
    state: {
        // state is required
        presence: {
            message: "^Please select a state"
        }
    },
    // Suboxone
    suboxone: {
      // Suboxone is required
      presence: {
          message: "^Please select an option"
      }
    },
    suboxone_effect: {
      // Suboxone is required
      presence: {
          message: "^Please select an option"
      }
    },
    ozempic_effect: {
      // Ozempic is required
      presence: {
          message: "^Please select an option"
      }
    },
    ozempic_q1: {
      // Ozempic is required
      presence: {
          message: "^Please select an option"
      }
    },
    roundup_q1: {
      // Roundup is required
      presence: {
          message: "^Please select an option"
      }
    },
    ivf_solution_effect: {
      // IVF Solution is required
      presence: {
          message: "^Please select an option"
      }
    },
    hair_straightener_effect: {
      // Hair Straightener is required
      presence: {
          message: "^Please select an option"
      }
    },
    hair_straightener_q1: {
      // Hair Straightener is required
      presence: {
          message: "^Please select an option"
      }
    },
    exactech_effect: {
      // Exactech is required
      presence: {
          message: "^Please select an option"
      }
    },
    qualifying_question: {
      // Qualifying Question is required
      presence: {
        message: "^Please select an option"
      }
    },
    qualifying_question_2: {
      // Qualifying Question is required
      presence: {
        message: "^Please select an option"
      }
    },
    qualifying_question_3: {
      // Qualifying Question is required
      presence: {
        message: "^Please select an option"
      }
    },
    broughton_q1: {
        presence: {
            message: "^Please select an option"
        }
    },
    broughton_q2: {
        presence: {
            message: "^Please select an option"
        }
    },
    broughton_q3: {
        presence: {
            message: "^Please select an option"
        }
    },
    broughton_q4: {
        presence: {
            message: "^Please select an option"
        }
    }
};

// Get all the forms
var validateForms = document.getElementsByClassName("js-validateForm");
var completeFunctions = [];

// If forms exist
if (validateForms.length) {
    (function () {
        // Define our constructor
        this.ValidateForm = function () {
            /*
            * Handle the form submit button tied to the even listener
            * Requires : The form being submitted
            */
            // foreach form found on the page
            var k = 0;
            var isLeadIDscriptSet = false;
            for (var i = 0; i < validateForms.length; i++) {
                // Get the submit button of the form (Document: must be a button with type 'submit')
                var submit_button = validateForms[i].querySelector('button[type="submit"]');
                // Get the any multistep form buttons that change the step (Document: must be have attribute 'data-step-change=[destination]')
                var step_change = validateForms[i].querySelectorAll('[data-step-change]');

                // If the submit button is found logic / else warn the user via console
                if (submit_button) {
                    // Add the event listener on click and remove the default behavior
                    const selectElement = validateForms[i].querySelector('#asds');

                    if (selectElement) {
                        selectElement.addEventListener('change', (e) => {
                            var submit_button = event.target.closest('.js-validateForm').querySelector('button[type="submit"]');
                            var lead_not_accepted_span = event.target.closest('.js-validateForm').querySelector('.lead-not-accepted');

                            if (e.target.value === 'No') {
                                lead_not_accepted_span = document.createElement('p');
                                lead_not_accepted_span.classList.add('lead-not-accepted');
                                lead_not_accepted_span.style.color = 'red';
                                lead_not_accepted_span.style.textAlign = 'center';
                                lead_not_accepted_span.textContent = 'Based on your answers, you do not qualify for this case review.';

                                submit_button.parentNode.insertBefore(lead_not_accepted_span, submit_button);
                                submit_button.disabled = true;
                                submit_button.style.opacity = 0.5;
                            }

                            if (e.target.value === 'Yes') {
                                if (lead_not_accepted_span) {
                                    lead_not_accepted_span.remove();
                                }
                                submit_button.disabled = false;
                                submit_button.style.opacity = 1;
                            }
                        });
                    }
                    submit_button.addEventListener("click", function (e) {
                        e.preventDefault();
                        handleFormSubmit(this.closest('.js-validateForm'));
                    });

                    isLeadIDscriptSet = checkLeadIDScript(isLeadIDscriptSet);

                    // Check to see if form has onsubmit function and attach attribute to form
                    if (validateForms[i].hasAttribute('data-on-submit')) {
                        completeFunctions[k] = validateForms[i].getAttribute('data-on-submit');
                        validateForms[i].setAttribute('data-on-submit-function', k);
                        k++;
                    }

                    // If we also found next buttons, attach the handler
                    if (step_change.length) {
                        // Start the form at step 1
                        validateForms[i]['data-current-step'] = 1;
                        // Attach listener to all buttons
                        for (var j = 0; j < step_change.length; j++) {
                            currentStep = j + 1;
                            // Check to see if form has step complete step listeners and attach attribute to step button
                            if (validateForms[i].hasAttribute('data-step-complete-' + currentStep)) {
                                completeFunctions[k] = validateForms[i].getAttribute('data-step-complete-' + currentStep);
                                step_change[j].setAttribute("data-complete-function", k);
                                k++;
                            }
                            // Add the event listener on click and remove the default behavior
                            step_change[j].addEventListener("click", function (e) {
                                e.preventDefault();
                                // Get the target step from the data-step-change attribute
                                var targetStep = this.getAttribute('data-step-change');
                                handleStepChange(this.closest('.js-validateForm'), targetStep);
                                // If button has attached attribute for step completion, run the function attached to to the step completion
                                if (this.hasAttribute('data-complete-function'))
                                    handleStepCompleteFunction(this.getAttribute('data-complete-function'));
                            });
                        }
                    }
                }
                else {
                    console.warn('A form was found but its missing a button with type submit');
                }
            }

            function checkLeadIDScript(isEnabled) {
                if (isEnabled) {
                    return;
                }

                initializeLeadIDScript();
                return true;
            }

            function initializeLeadIDScript() {
                var mainScript = document.createElement('script');
                mainScript.id = 'LeadiDscript_campaign';
                mainScript.type = 'text/javascript';
                mainScript.async = true;
                mainScript.src = '//create.lidstatic.com/campaign/0b92ac32-ff2b-c615-2c71-e35237a3401b.js?snippet_version=2';

                document.body.appendChild(mainScript);

                var noscriptImage = document.createElement('img');
                noscriptImage.src = '//create.leadid.com/noscript.gif?lac=F54A31CF-AAC9-ABB2-7E23-1FC035B80391&lck=0b92ac32-ff2b-c615-2c71-e35237a3401b&snippet_version=2';

                var noscriptElement = document.createElement('noscript');
                noscriptElement.appendChild(noscriptImage);

                document.body.appendChild(noscriptElement);
            };

            function handleStepCompleteFunction(functionNumber) {
                if (typeof completeFunctions[functionNumber] !== 'undefined' && typeof window[completeFunctions[functionNumber]] === 'function') {
                    window[completeFunctions[functionNumber]]();
                } else {
                    console.warn('Function for step complete missing.')
                }
            }
            function handleOnSubmitFunction(functionNumber) {
                if (typeof completeFunctions[functionNumber] !== 'undefined' && typeof window[completeFunctions[functionNumber]] === 'function') {
                    return window[completeFunctions[functionNumber]]();
                } else {
                    console.warn('Function for on submit missing.');
                    return false;
                }
            }

            function validateTextConsent(form) {
                var checkbox = form.querySelector('input[name=leadid_tcpa_disclosure]');
                var checkboxLabel = form.querySelector('.c-form__group--disclaimer');

                if (checkbox && checkboxLabel && !checkbox.checked) {
                    checkboxLabel.classList.add('has-form-error');
                    return false;
                }

                return true;
            }


            /*
            * Handle the form submit button thats tied to the event listener
            */
            function handleFormSubmit(form) {
                // Don't rerun submission while we are submitting
                if (!form['data-submitting']) {
                    //analytics trigger
                    if (typeof formStepSubmitEvent === "function") {
                        formStepSubmitEvent(form);
                    }

                    if (typeof window.formSubmitEvent === "function") {
                        window.formSubmitEvent(form);
                    }
                    
                    // Throttle the form submission by assigning it a boolean to track submission
                    form['data-submitting'] = true;
                    // First we gather the values from the form
                    var values = validate.collectFormValues(form);
                    // Grab all the inputs in the form
                    var inputs = form.querySelectorAll('input[name], select[name], textarea[name]');
                    // Next we gather the constraints (rules)
                    var constraints = getConstraints(inputs);
                    // Provide warning if no required fields found
                    if (Object.keys(constraints).length === 0 && constraints.constructor === Object) console.warn("No matching rules were found. Did you remember to mark fields as 'required'?");
                    // then we validate the values against the constraints
                    var errors = validate(values, constraints);
                    // next we update the form to reflect the results
                    var isValid = showValidationErrors(form, inputs, errors || {});
                    // If all constraints pass
                    if (isValid) {
                        //analytics triggers
                        if (typeof formStepSuccessEvent === "function") {
                            if (form.querySelectorAll('.c-form__steps').length) {
                                formStepSuccessEvent(form);
                            }
                        }
                        if (typeof formSuccessEvent === "function") {
                            formSuccessEvent(form);
                        }

                        // pass to the submit function
                        submitTheValidForm(form, values);
                    }
                    else {
                        form['data-submitting'] = false;
                    }
                }
            }

            /*
            * Handle the form step change buttons that are tied to the event listener
            */
            function handleStepChange(form, step) {
                // Don't rerun submission while we are submitting
                if (step && !form['data-submitting']) {
                    // Throttle the form submission by assigning it a boolean to track submission
                    form['data-submitting'] = true;
                    // If we're already in that step, do nothing
                    if (form['data-current-step'] == step) {
                        form['data-submitting'] = false;
                        return;
                    }
                    // If we're going back, don't do any validation
                    else if (form['data-current-step'] > step) {
                        transitionSteps(form, step);
                    }
                    // If we're going forward, validate normally
                    else {
                        //analytics trigger
                        if (typeof formStepSubmitEvent === "function") {
                            formStepSubmitEvent(form);
                        }

                        // First we gather the values from the form
                        var values = validate.collectFormValues(form);
                        // Grab the inputs in the form that correspond to the current step
                        var activeStep = form.querySelector('[data-step="' + form['data-current-step'] + '"]');
                        var inputs = activeStep.querySelectorAll('input[name], select[name]');
                        // Next we gather the constraints (rules)
                        var constraints = getConstraints(inputs);
                        // Provide warning if no required fields found
                        if (Object.keys(constraints).length === 0 && constraints.constructor === Object) console.warn("No matching rules were found. Did you remember to mark fields as 'required'?");
                        // then we validate the values against the constraints
                        var errors = validate(values, constraints);
                        // next we update the form to reflect the results
                        var isValid = showValidationErrors(form, inputs, errors || {});
                        // If all constraints pass
                        if (isValid) {
                            //analytics trigger
                            if (typeof formStepSuccessEvent === "function") {
                                formStepSuccessEvent(form);
                            }

                            // pass to the transition function
                            transitionSteps(form, step);
                        }
                        else {
                            form['data-submitting'] = false;
                        }
                    }
                }
            }

            /*
            * Fade transition between different steps
            */
            function transitionSteps(form, step) {
                var has_nav = false;
                var activeStep = form.querySelector('[data-step="' + form['data-current-step'] + '"]');
                var targetStep = form.querySelector('[data-step="' + step + '"]');

                if (form.querySelector('.c-form__nav')) {
                    var has_nav = true;
                    var activeNav = form.querySelector('.c-form__nav-button[data-step-change="' + form['data-current-step'] + '"]');
                    var targetNav = form.querySelector('.c-form__nav-button[data-step-change="' + step + '"]');
                }

                // Fade out current step
                if (has_nav) {
                    activeNav.classList.remove('is-active');
                }
                fadeOut(activeStep, 500, function () {
                    // Fade in next step
                    if (has_nav) {
                        targetNav.classList.add('is-active');
                    }
                    fadeIn(targetStep, 500, function () {
                        // Unlock form by setting submitting boolean to false
                        form['data-current-step'] = step;
                        form['data-submitting'] = false;
                    });
                });
            }

            /*
            * Fade out helper
            */
            function fadeOut(element, time, cb) {
                var op = 1;  // initial opacity
                var timer = setInterval(function () {
                    if (op <= 0.1) {
                        clearInterval(timer);
                        element.style.display = 'none';
                        cb();
                    }
                    element.style.opacity = op;
                    element.style.filter = 'alpha(opacity=' + op * 100 + ")";
                    op -= 50 / time;
                }, 50);
            }

            /*
            * Fade in helper
            */
            function fadeIn(element, time, cb) {
                var op = 0;  // initial opacity
                element.style.opacity = op;
                element.style.filter = 'alpha(opacity=' + op + ")";
                element.style.display = 'block';
                var timer = setInterval(function () {
                    if (op >= 1) {
                        clearInterval(timer);
                        cb();
                    }
                    element.style.opacity = op;
                    element.style.filter = 'alpha(opacity=' + op * 100 + ")";
                    op += 50 / time;
                }, 50);
            }

            /*
            * getConstraints AKA the rules | Mixes Global, Custom and Overrides
            */
            function getConstraints(inputs) {
                // Declare variable to hold all the constraints used to validate form
                var constraints = {};
                // Check every form input
                for (var i = 0; i < inputs.length; i++) {
                    // Grab constraint
                    if (defaultConstraints[inputs[i].name]) {
                        constraints[inputs[i].name] = defaultConstraints[inputs[i].name];
                        // Remove presence constraint if it is not required
                        if (!inputs[i].hasAttribute('required')) delete constraints[inputs[i].name].presence;
                    }
                }

                return constraints;
            }

            /*
            * Show the errors in the view
            */
            function showValidationErrors(form, inputs, errors) {
                // Input is valid until we determine otherwise
                var valid = true;
                // Remove all validation errors on the page
                var errorMessages = document.getElementsByClassName('js-errorMessage');
                var ariaInvalid = document.querySelectorAll('[aria-invalid]');

                valid = validateTextConsent(form);

                while (errorMessages[0]) {
                    errorMessages[0].remove();
                }

                for (var i = 0; i < ariaInvalid.length; i++) {
                    ariaInvalid[i].removeAttribute('aria-invalid');
                    ariaInvalid[i].removeAttribute('aria-describedBy');
                }
                // Loop through all the inputs and display the errors
                for (var i = 0; i < inputs.length; i++) {
                    if (inputs[i].getAttribute('type') !== 'hidden') {
                        // Check input for errors
                        inputValid = checkInputError(inputs[i], errors && errors[inputs[i].name], form);
                        // If any input was invalid, the validity of the form is false
                        if (!inputValid) {
                            valid = false;
                        }
                    }

                }
                // return true or false
                return valid;
            }

            /*
            * Function reaches out and updates the DOM errors
            */
            function checkInputError(input, errors, form) {

                // Error Class Name (attached to inputs after error)
                var errorClassName = 'has-error';

                // Error Message Class Name (used to insert and show error message)
                var errorMessageClassName = 'js-errorMessage';

                // Parent form group of input (manages errors)
                var formGroup = input.closest('.js-formGroup');

                // If the error exists apply the class "has-error" and set the error message on the "js-errorMessage" element
                if (errors) {
                    // Check if associated error label already exists
                    if (input.hasAttribute('aria-describedBy') && document.getElementById(input.getAttribute('aria-describedBy'))) {
                        errorSpan = document.getElementById(input.getAttribute('aria-describedBy'));
                        errorSpan.innerHTML = errors[0];
                        // Otherwise, create error message
                    } else {
                        // Create error message span
                        var errorSpan = document.createElement('span');
                        errorSpan.className = "c-form__label c-form__label--error js-errorMessage";
                        errorSpan.innerHTML = errors[0];
                        if (input.type != "radio") {
                            errorSpan.id = "error_" + input.id;
                            formGroup.appendChild(errorSpan);
                            input.setAttribute('aria-describedBy', "error_" + input.id);
                            input.setAttribute('aria-invalid', "true");
                        } else {
                            errorSpan.id = "error_" + input.name;
                            input.setAttribute('aria-describedBy', "error_" + input.name);
                            input.setAttribute('aria-invalid', "true");
                            if (formGroup.querySelector("#error_" + input.name) == null) {
                                formGroup.appendChild(errorSpan);
                            }
                        }
                    }

                    // Add the error class to the form-group (CSS does the rest)
                    if (formGroup.className.includes(errorClassName) == false) {
                        formGroup.className += ' ' + errorClassName;
                    }

                    // ADD the validation event listener on input
                    // if the input-listener class already exists do not add it again
                    // keep the binding events in a loop and let the browser do work
                    if (input.className.includes('js-inputListener') == false) {
                        input.className += ' js-inputListener';
                        addInputEventListener(input, form);
                    }

                    // return false aka error found
                    return false;
                }
                // Remove the errors from the inputs
                else {
                    // Remove error class on input
                    if (formGroup !== null)
                        formGroup.classList.remove(errorClassName);
                    // Remove aria labels and error message
                    if (input.hasAttribute('aria-describedBy') && document.getElementById(input.getAttribute('aria-describedBy'))) {
                        document.getElementById(input.getAttribute('aria-describedBy')).remove();
                    }
                    input.removeAttribute('aria-invalid');
                    input.removeAttribute('aria-describedBy');
                    // return true aka no error found
                    return true;
                }
            }

            /*
            * After the initial submission if errors are returned we add an
            * event listener to detect changes for the elements that did return errors
            * so the user moving forward now gets "live" validation
            */
            function addInputEventListener(input, form) {
                // el handlers
                // If: select / radio / checkbox
                if (input.type == 'select-one' || input.type == 'radio' || input.type == 'checkbox') {
                    input.addEventListener('change', function (e) {
                        individualInputSubmit(input, form);
                    });
                }
                // Other inputs
                else {
                    // TODO test input event on IE 9
                    input.addEventListener('input', function (e) {
                        individualInputSubmit(input, form);
                    });
                }
            }

            /*
            * This will validate a single input instead of a full form this is needed for
            * the event listener
            */
            function individualInputSubmit(input, form) {
                // grab the constraints (rules)
                var constraints = getConstraints([input]);
                // next validate them against the constraints
                // IE 9 and under approved version to do what 1 line should
                var inputError = {};
                inputError[input.name] = input.value;
                var errors = validate(inputError, constraints);
                // Check rules for a single input
                checkInputError(input, errors && errors[input.name], form);
            }

            /*
            * SUBMIT - this houses the final submission function
            */
            function submitTheValidForm(form, values) {
                // Make sure the honey pot field is empty before submitting
                if (!values.f_name) {
                    // By Default, form submits as normal
                    submit_form = true;
                    // If the form has an on-submit function, then run that function to see if it should still submit the form as normal
                    if (form.hasAttribute('data-on-submit-function')) {
                        submit_form = handleOnSubmitFunction(form.getAttribute('data-on-submit-function'));
                    }
                    if (submit_form) {
                        if (form.action.indexOf('/FormParser.php') >= 0) {
                            sendData(form);
                        } else {
                            form.submit();// /scholarship form on asb and other forms actions may not support ajax yet
                        }
                    } else {
                        form['data-submitting'] = false;
                    }
                }

            }

            const isLocalStorageAvailable = (storage) => {
                try {
                const test = 'test';
                storage.setItem(test, test);
                storage.removeItem(test);
                return true;
                } catch (e) {
                console.log(e);
                return false;
                }
            }

            const saveUserInfoToLocal = (fullName, email, diagnosis, phoneNumber, requestedService) => {
                if (isLocalStorageAvailable(localStorage)) {
                    localStorage.setItem("fullName", fullName);
                    localStorage.setItem("email", email);
                    localStorage.setItem("diagnosis", diagnosis);
                    localStorage.setItem("phoneNumber", phoneNumber);
                    localStorage.setItem("requested_service", requestedService);
                } else {
                    console.warn("No local storage available");
                }
            }

            function sendData(form) {
                form.classList.add('c-form--submitting');
                form.getElementsByClassName('c-form__submit')[0].disabled = true;
                form.getElementsByClassName('c-form__submit-error')[0].style.display = "none";
                form.getElementsByClassName('c-form__network-error')[0].style.display = "none";

                var XHR = new XMLHttpRequest();

                let parsedTrackingData;

                try {
                    const TRACKING_DATA = localStorage.getItem('USER_SESSION');
                    parsedTrackingData = JSON.parse(TRACKING_DATA);
                } catch (e) {
                    parsedTrackingData = false;
                }

                // Currently not using UserSession for now
                // const USER_SESSION = localStorage.getItem('USER_SESSION');
                // const parsedUserSession = JSON.parse(USER_SESSION);

                // console.log(parsedTrackingData,parsedUserSession); console log localStorage

                // Bind the FormData object and the form element
                var FD = new FormData(form);
                FD.append("ajax", 1);
                if(parsedTrackingData) {
                    FD.append('tracking_data', JSON.stringify(parsedTrackingData));

                    if (parsedTrackingData.queryParameters.lead_attribution) {
                        FD.append('lead_attribution', parsedTrackingData.queryParameters.lead_attribution);
                    }

                }

                // FD.append('USER_SESSION', parsedUserSession.pages); stashing this for later to capture user session data

                // for (var pair of FD.entries()) {
                //     console.log(pair[0] + ', ' + pair[1]);
                // }
                //stashing this bit to help debug / console log FormData


                // Define what happens on successful data submission
                XHR.addEventListener("load", function (event) {//if the form parser returns any status code, then it loaded

                    if (XHR.status === 200) {//we are only considering a 200 status to be successful

                        try {
                            if (typeof mixpanel === 'object') {
                                mixpanel.track("Form Submit Success", {});
                            }
                        } catch (e) {
                            Bugsnag.notify(new Error('Mixpanel Form Submit Success Event Unsuccessful'), function (e) { });
                        }

                        var tyParams = [];
                        var tyPage = XHR.responseURL;

                        if (form.querySelector('#diagnosis-Mesothelioma') && form.querySelector('#diagnosis-Mesothelioma').checked) tyParams.push("diagnosis=mesothelioma");

                        // Broughton Partner Override
                        if (!FD.get('partner_override')) {
                            var cid = FD.get('c_id');

                            // Rewrite redirect if its CPAP and is not MQL
                            if (cid == 170 || cid == 171) {
                                var effect = FD.get('cpap_effect');
                                var cpap = FD.get('cpap');
                                var cpapMql = ['Yes', 'Unsure', 'Cancer', 'Respiratory injury', 'Awaiting diagnosis'];

                                if (!cpapMql.includes(effect) || !cpapMql.includes(cpap)) {
                                    tyPage = "/thank-you-not-accepting/";
                                }
                            }


                            // Rewrite redirect if its Suboxone and in a non accepting state
                            if (cid == 183) {
                                var suboxoneEffect = FD.get('suboxone_effect');
                                var suboxone = FD.get('suboxone');
                                var state = FD.get('state');
                                var suboxoneMql = ['Yes', 'Cavities', 'Tooth fractures or decay', 'Tongue or gum injuries'];
                                var invalid_states = [
                                    'AK', 'AR', 'AZ', 'CA', 'CO', 'DE', 'GA', 'HI', 'IA', 'ID', 'IL', 'IN', 'KS',
                                    'MA', 'MD', 'MI', 'MS', 'MT', 'NC', 'NH', 'NJ', 'NM', 'NV', 'NY', 'OH', 'OK',
                                    'OR', 'PA', 'RI', 'SC', 'SD', 'UT', 'VA', 'VT', 'WA', 'WI', 'WV', 'Unsure'
                                ];

                                if ((!suboxoneMql.includes(suboxoneEffect) || !suboxoneMql.includes(suboxone)) || invalid_states.includes(state)) {
                                    tyPage = "/thank-you-not-accepting/";
                                }
                            }

                            // Rewrite redirect based on Ozempic MQL
                            if (cid == 185) {
                                var ozempicEffect = FD.get('ozempic_effect');
                                var ozempicMql = ['Death', 'Gastroparesis', 'Persistent vomiting', 'Yes', 'No', 'Vision Loss'];

                                if (!ozempicMql.includes(ozempicEffect)) {
                                    tyPage = "/thank-you-not-accepting/";
                                }
                            }
                        }

                        if (tyParams.length > 0) {
                            window.location.href = tyPage + '?' + tyParams.join('&');
                        } else {
                            window.location.href = tyPage;
                        }
                    } else {
                        sumbitError(form);
                    }
                });

                // Define what happens in case of error
                XHR.addEventListener("error", function (event) {
                    sumbitError(form);
                });

                // Set up our request
                XHR.open("POST", form.action);//we are going to use the form action to send

                //try to catch any errors with mixpanel, but continue to execute
                try {
                    if (typeof mixpanel === 'object') {
                        if (FD.entries()) mixpanel.track("Form Submit Attempt", Object.fromEntries(FD.entries()));//this should send all form fields to mixpanel
                        if (FD.get('full_name')) mixpanel.people.set({ "$name": FD.get('full_name') });
                        if (FD.get('email')) mixpanel.people.set({ "$email": FD.get('email') });
                        if (FD.get('phone')) mixpanel.people.set({ "$phone": FD.get('phone') });
                    }
                } catch (e) {
                    Bugsnag.notify(new Error('Mixpanel Form Submit Attempt Event Unsuccessful'), function (e) { });
                }

                // The data sent is what the user provided in the form
                XHR.send(FD);

            }

            function sumbitError(form) {
                form.classList.remove('c-form--submitting');
                form.getElementsByClassName('c-form__submit')[0].disabled = false;

                try {
                    if (typeof mixpanel === 'object') {
                        mixpanel.track("Form Submit Error", { "count": errorNum + 1 });
                    }
                } catch (e) {
                    Bugsnag.notify(new Error('Mixpanel Form Submit Error Event Unsuccessful'), function (e) { });
                }

                if (errorNum < errorMax) {
                    form['data-submitting'] = false;
                    form.getElementsByClassName('c-form__submit-error')[0].style.display = "block";
                    Bugsnag.notify(new Error('form ajax network parser error'), function (e) {
                        e.severity = 'error'
                        e.context = 'form-ajax-error'
                        e.addMetadata('submit-attempts', { count: errorNum + 1 })
                    });
                } else {
                    form.classList.add('c-form--disabled');
                    form.getElementsByClassName('c-form__network-error')[0].style.display = "block";
                    Bugsnag.notify(new Error('form ajax network parser error disabled'), function (e) {
                        e.severity = 'error'
                        e.context = 'form-ajax-error-disabled'
                        e.addMetadata('submit-attempts', { count: errorNum + 1 })
                    });
                }
                errorNum++;
            }

            //***********************************
            //************** Masks **************
            //***********************************

            /*
            * Phonenumber Mask | While typing listener
            */
            var phoneMasks = document.getElementsByName("phone");
            // For each phone-mask add an event listener that formats as well as blocks anything other than
            // integers from being added to the input
            for (i = 0; i < phoneMasks.length; i++) {
                phoneMasks[i].addEventListener('input', function (e) {
                    var x = e.target.value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
                    e.target.value = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
                });
            }

            /*
            * Zip Mask | While typing listener
            */
            var zipMasks = document.getElementsByName("zip_code");
            // For each zip-mask add an event listener that formats as well as blocks anything other than
            // integers from being added to the input
            for (i = 0; i < zipMasks.length; i++) {
                zipMasks[i].addEventListener('input', function (e) {
                    //var x = e.target.value.replace(/\D/g, '').match(/(\d{5}([\-]\d{4})?)/);
                    var x = e.target.value.replace(/\D/g, '').match(/(\d{0,5})(\d{0,4})/);
                    e.target.value = !x[1] ? x[1] : x[1] + (x[2] ? '-' + x[2] : ''); //Brute force
                });
            }

            //***********************************
            //************ polyfills ************
            //***********************************

            // Matches polyfill
            Element.prototype.matches = Element.prototype.matches ||
                Element.prototype.matchesSelector ||
                Element.prototype.webkitMatchesSelector ||
                Element.prototype.msMatchesSelector ||
                function (selector) {
                    var node = this, nodes = (node.parentNode || node.document).querySelectorAll(selector), i = -1;
                    while (nodes[++i] && nodes[i] !== node);
                    return !!nodes[i];
                };

            // Closest polyfill - IE has no support
            Element.prototype.closest = Element.prototype.closest ||
                function (selector) {
                    var el = this;
                    while (el.matches && !el.matches(selector)) el = el.parentNode;
                    return el.matches ? el : null;
                };

            // Polyfill Includes
            if (!String.prototype.includes) {
                String.prototype.includes = function (search, start) {
                    'use strict';
                    if (typeof start !== 'number') {
                        start = 0;
                    }
                    if (start + search.length > this.length) {
                        return false;
                    }
                    else {
                        return this.indexOf(search, start) !== -1;
                    }
                };
            }

            /**
             * ChildNode.remove() polyfill
             * https://gomakethings.com/removing-an-element-from-the-dom-the-es6-way/
             * @author Chris Ferdinandi
             * @license MIT
             */
            (function (elem) {
                for (var i = 0; i < elem.length; i++) {
                    if (!window[elem[i]] || 'remove' in window[elem[i]].prototype) continue;
                    window[elem[i]].prototype.remove = function () {
                        this.parentNode.removeChild(this);
                    };
                }
            })(['Element', 'CharacterData', 'DocumentType']);

            // Polyfill Class List
            "document" in self && ("classList" in document.createElement("_") && (!document.createElementNS || "classList" in document.createElementNS("http://www.w3.org/2000/svg", "g")) ? function () { "use strict"; var t, e, n = document.createElement("_"); n.classList.add("c1", "c2"), n.classList.contains("c2") || ((t = function (t) { var e = DOMTokenList.prototype[t]; DOMTokenList.prototype[t] = function (t) { var n, i = arguments.length; for (n = 0; n < i; n++)t = arguments[n], e.call(this, t) } })("add"), t("remove")), n.classList.toggle("c3", !1), n.classList.contains("c3") && (e = DOMTokenList.prototype.toggle, DOMTokenList.prototype.toggle = function (t, n) { return 1 in arguments && !this.contains(t) == !n ? n : e.call(this, t) }), n = null }() : function (t) { "use strict"; var e, n, i, o, s; if ("Element" in t) if ((e = function (t, e) { this.name = t, this.code = DOMException[t], this.message = e }).prototype = Error.prototype, n = function (t, n) { if ("" === n) throw new e("SYNTAX_ERR", "An invalid or illegal string was specified"); if (/\s/.test(n)) throw new e("INVALID_CHARACTER_ERR", "String contains an invalid character"); return [].indexOf.call(t, n) }, o = function () { return new i(this) }, ((i = function (t) { for (var e = String.prototype.trim.call(t.getAttribute("class") || ""), n = e ? e.split(/\s+/) : [], i = n.length, o = 0; o < i; o++)this.push(n[o]); this._updateClassName = function () { t.setAttribute("class", this.toString()) } }).prototype = []).item = function (t) { return this[t] || null }, i.prototype.contains = function (t) { return -1 !== n(this, t += "") }, i.prototype.add = function () { var t, e = arguments, i = 0, o = e.length, s = !1; do { t = e[i] + "", -1 === n(this, t) && (this.push(t), s = !0) } while (++i < o); s && this._updateClassName() }, i.prototype.remove = function () { var t, e, i = arguments, o = 0, s = i.length, r = !1; do { for (t = i[o] + "", e = n(this, t); -1 !== e;)this.splice(e, 1), r = !0, e = n(this, t) } while (++o < s); r && this._updateClassName() }, i.prototype.toggle = function (t, e) { var n, i; return t += "", (i = (n = this.contains(t)) ? !0 !== e && "remove" : !1 !== e && "add") && this[i](t), !0 === e || !1 === e ? e : !n }, i.prototype.toString = function () { return this.join(" ") }, Object.defineProperty) { s = { get: o, enumerable: !0, configurable: !0 }; try { Object.defineProperty(t.Element.prototype, "classList", s) } catch (e) { -2146823252 === e.number && (s.enumerable = !1, Object.defineProperty(t.Element.prototype, "classList", s)) } } else Object.prototype.__defineGetter__ && t.Element.prototype.__defineGetter__("classList", o) }(self));
        } // end of validate constructor

    }()); // end of immediately invoked functional expression

    // Initialize the validator
    new ValidateForm();
} // end of if forms found
